import { render, staticRenderFns } from "./Listareserva.vue?vue&type=template&id=774e935c&"
import script from "./Listareserva.vue?vue&type=script&lang=js&"
export * from "./Listareserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports